<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAddLog()">Add Log</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onEditLog()">Edit Log</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onDeleteLog()">Delete Log</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onPrintLog()">Print Log</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstGuidance"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedGuidance"
		dataKey="GuidanceID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--GuidanceDTDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="GuidanceDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Comments-->
				<th>
					<p-columnFilter type="text" field="Comments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter field="LastName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterLastName
								[ngModel]="value"
								[options]="lstLastName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="GuidanceDT">Date/Time<p-sortIcon field="GuidanceDT"></p-sortIcon></th>
				<th pSortableColumn="Comments">Comments<p-sortIcon field="Comments"></p-sortIcon></th>
				<th pSortableColumn="LastName">Administrator<p-sortIcon field="LastName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Guidance>
			<tr [pSelectableRow]="Guidance" (dblclick)="onRowDblClick(Guidance)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Guidance[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
